import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

const BASE_URL = "/vehicle-spare-keys"

export const getVehicleSpareKeys = async (params = {}) => {
  const { data } = await apiClient.get(BASE_URL, { params })
  return data
}

export const getVehicleSpareKey = async id => {
  const { data } = await apiClient.get(`${BASE_URL}/${id}`)
  return data
}

export const createVehicleSpareKey = async payload => {
  const { data } = await apiClient.post(BASE_URL, payload)
  return data
}

export const updateVehicleSpareKey = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`${BASE_URL}/${id}`, payload)
  return data
}

export const deleteVehicleSpareKey = async idOrPayload => {
  const id = idOrPayload?.id ?? idOrPayload
  const { data } = await apiClient.delete(`${BASE_URL}/${id}`)
  return data
}

export const getVehicleSpareKeyCustomerSuggestions = async (params = {}) => {
  const { data } = await apiClient.get(`${BASE_URL}/customer-suggestions`, { params })
  return data
}

export const downloadInStockVehicleSpareKeysPdf = async ({ params = {}, onStart, onEnd } = {}) => {
  return downloadAndOpenFile({
    url: `${BASE_URL}/in-stock/pdf`,
    params,
    openInNewTab: false,
    filename: "in-stock-spare-keys.pdf",
    onStart,
    onEnd,
  })
}
